import { Loader } from 'react-feather';

interface SpinLoaderProps {
    className?: string;
}

export function SpinLoader({ className }: SpinLoaderProps) {
    return (<Loader className={`${className} w-4 h-4 animate-spin`} />);
}